import type { NotifyPort } from '@/features/messages/domain/notify'
import type { Customer, CustomerUpsertInput, CustomerPort } from '../domain/customer'

const upsertCustomer = async (port: CustomerPort, data: CustomerUpsertInput, notify: NotifyPort): Promise<Customer> => {
	try {
		const result = await port.upsert(data)
		notify.success(data.id ? 'customer.updated' : 'customer.created')
		return result
	} catch (err) {
		notify.error(data.id ? 'customer.updateFailed' : 'customer.createFailed')
		throw err
	}
}

export type { CustomerUpsertInput as UpsertInput }
export { upsertCustomer }
